<template>
    <div class="tw:space-y-4" :class="customClass">
        <div
            v-for="(item, index) in items"
            :key="index"
            class="tw:flex tw:items-center tw:gap-3"
        >
            <!-- Label -->
            <span
                class="tw:text-sm tw:font-medium tw:text-gray-600 tw:w-28 tw:flex-shrink-0 tw:text-right"
                :title="item.label"
            >
                {{ item.label }}
            </span>

            <!-- Bar track -->
            <div class="tw:flex-grow tw:bg-gray-100 tw:rounded-full tw:h-2.5 tw:overflow-hidden">
                <div
                    class="tw:h-full tw:rounded-full tw:transition-all tw:duration-700 tw:ease-out"
                    :class="barColor(item.value, item.max)"
                    :style="{ width: pct(item.value, item.max) + '%' }"
                >
                </div>
            </div>

            <!-- Value label -->
            <span class="tw:text-sm tw:font-semibold tw:text-gray-700 tw:w-14 tw:text-right tw:flex-shrink-0">
                {{ item.value }}<span class="tw:font-normal tw:text-gray-400">/{{ item.max }}</span>
            </span>
        </div>

        <div v-if="!items.length" class="tw:text-center tw:text-gray-400 tw:text-sm tw:py-6">
            No hay datos disponibles
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        items: {
            type: Array,
            default: () => []
        },
        customClass: {
            type: String,
            default: ''
        }
    })

    function pct(value, max) {
        if (!max || max <= 0) return 0
        return Math.round((Math.min(value, max) / max) * 100)
    }

    function barColor(value, max) {
        const p = pct(value, max)
        if (p >= 80) return 'tw:bg-emerald-500'
        if (p >= 60) return 'tw:bg-lime-500'
        if (p >= 40) return 'tw:bg-yellow-500'
        return 'tw:bg-red-500'
    }
</script>
